import { App } from 'vue'
import NumberRangePicker from './LpNumberRangePicker.vue'

NumberRangePicker.install = (Vue: App) => {
  Vue.component(NumberRangePicker.name, NumberRangePicker)
}

export default NumberRangePicker
